import React from 'react';
import { LessThanMedium, Medium } from '@jg/responsive';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import Modal from 'src/components/Modal';
import DesktopEncourageShare from 'src/components/Page/EncourageShare/DesktopEncourageShare';
import MobileEncourageShare from 'src/components/Page/EncourageShare/MobileEncourageShare';
import {
  isLocalStorageAvailable,
  isSessionStorageAvailable,
  isPropertyInLocalAndSessionStorage,
} from 'src/helpers/browser';
import { AppState } from 'src/redux/modules';
import { PageStatus } from 'src/helpers/api/pages';
import { Dispatch, bindActionCreators } from 'redux';
import { analyticsClick, AnalyticsClick } from 'src/redux/modules/analytics';
import { AnalyticsPageView } from 'src/components/Analytics';
import { ShareActionOptions, shareByWhatsApp } from 'src/redux/modules/page';
import { enrol } from 'src/helpers/api/ab';

const propertyName = 'isSharePromptDismissed';

type OwnProps = RouteComponentProps<void>;

interface StateProps {
  id: string;
  status: PageStatus;
  ownerName: string;
  renderAfter: number;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  targetCurrency: Currency;
  isOwner: boolean;
  pageName: string;
}

function mapStateToProps(state: AppState): StateProps {
  return {
    id: state.page.id,
    status: state.page.status,
    ownerName: state.page.ownerName,
    socialShareUrl: state.page.socialShareUrl,
    targetAmount: state.page.targetAmount,
    pitchFor: state.page.pitchFor,
    targetCurrency: state.page.targetCurrency,
    renderAfter: state.page.renderAfter,
    isOwner: state.page.isOwnerRequested,
    pageName: state.page.name,
  };
}

interface DispatchProps {
  analyticsClick: AnalyticsClick;
  shareByWhatsApp: (options: ShareActionOptions) => void;
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): DispatchProps {
  return bindActionCreators(
    {
      analyticsClick,
      shareByWhatsApp,
    },
    dispatch
  );
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  showEncourageShareModal: boolean;
  dualShareTestEnabled: boolean;
}

export class EncourageShareContainer extends React.Component<Props, State> {
  state = {
    showEncourageShareModal: false,
    dualShareTestEnabled: false,
  };

  handleModalClose = () => {
    const { id } = this.props;

    if (isSessionStorageAvailable() && isLocalStorageAvailable()) {
      window.localStorage.setItem(`${propertyName}:${id}`, 'true');
      window.sessionStorage.setItem(propertyName, 'true');
    }

    this.setState({
      showEncourageShareModal: false,
    });

    this.props.analyticsClick({
      event: 'click',
      subtype: 'skip > share prompt',
      pageSection: 'page > share prompt',
      eventValue: 'dismiss',
    });
  };

  async componentDidMount() {
    const {
      status,
      id,
      renderAfter,
      isOwner,
      pageName,
      location: { pathname },
    } = this.props;

    setTimeout(() => {
      this.setState({
        showEncourageShareModal:
          !isPropertyInLocalAndSessionStorage({
            localPropertyName: `${propertyName}:${id}`,
            sessionPropertyName: propertyName,
          }) &&
          status === 'Active' &&
          !isOwner &&
          pathname === `/${pageName}`,
      });
    }, renderAfter);

    this.setState({
      dualShareTestEnabled:
        (await enrol('cf_share_prompt_mobile_dual_share')) === 'B',
    });
  }

  render() {
    const {
      ownerName,
      socialShareUrl,
      targetAmount,
      pitchFor,
      targetCurrency,
    } = this.props;
    const { showEncourageShareModal, dualShareTestEnabled } = this.state;

    if (!showEncourageShareModal) {
      return null;
    }

    return (
      <Modal
        isOpen
        onClose={this.handleModalClose}
        colorTheme="dark"
        large
        maintainPosition
      >
        <AnalyticsPageView
          eventValue="share prompt"
          pageSection="page > share prompt"
          subtype="share prompt"
        >
          <LessThanMedium>
            <MobileEncourageShare
              ownerName={ownerName}
              closeModal={this.handleModalClose}
              socialShareUrl={socialShareUrl}
              targetAmount={targetAmount}
              shareByWhatsApp={this.props.shareByWhatsApp}
              pitchFor={pitchFor}
              targetCurrency={targetCurrency}
              dualShareTest={dualShareTestEnabled}
            />
          </LessThanMedium>
          <Medium>
            <DesktopEncourageShare
              ownerName={ownerName}
              closeModal={this.handleModalClose}
            />
          </Medium>
        </AnalyticsPageView>
      </Modal>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EncourageShareContainer)
);



// WEBPACK FOOTER //
// ./src/containers/page/EncourageShareContainer.tsx